var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tag',{attrs:{"rounded":"","type":"is-dark"}},[_vm._v(_vm._s(_setup.coalescedText))])
}
var staticRenderFns = []

export { render, staticRenderFns }